import React from 'react';
import PropTypes from 'prop-types';
import { numberWithCommas } from '../utils/displayHelpers.js';
import Styles from './summarytable.module.scss';

const ContactsRow = props => (props.contacts != null ?
  <tr >
    <th className={Styles.service}>{numberWithCommas(props.contacts)} {props.name}</th>
    <td className={Styles.price}>{props.price}</td>
  </tr>
  : ''
);

ContactsRow.propTypes = {
  contacts: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
};

export default ContactsRow;



// WEBPACK FOOTER //
// ./src/components/ContactsRow.jsx